function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["message", "content", "type", "filled", "icon", "children"];
var _templateObject;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { forwardRef, isValidElement } from 'react';
import { Alert, Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/styles';
var StyledAlert = styled(Alert)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & {\n    padding: 1rem;\n    box-shadow: 0 18px 24px rgba(0, 0, 0, 0.1),\n      0 4px 12px rgba(41, 44, 49, 0.18),\n      0 1px 3px rgba(44, 49, 56, 0.2);\n    border-radius: 6px;\n    justify-content: flex-start;\n    align-items: flex-start;\n\n    .MuiAlert-message {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      padding: 0;\n    }\n\n    .MuiAlert-action {\n      padding: 0;\n      padding-left: 1rem;\n    }\n  }\n"])));

/**
 * Determines where the specified content should be rendered as a React element or a MUI Typography element.
 *
 * If content should be rendered as Typography, specified values in `attr` will be passed through to the Typography.
 */
function _chooseValidElement(content, attrs) {
  if (!content) return null;
  if ( /*#__PURE__*/isValidElement(content)) return content;
  return /*#__PURE__*/React.createElement(Typography, attrs, content);
}
var BrandAlert = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var message = _ref.message,
    content = _ref.content,
    type = _ref.type,
    filled = _ref.filled,
    icon = _ref.icon,
    children = _ref.children,
    attrs = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(StyledAlert, _extends({
    ref: ref
  }, attrs, {
    severity: type,
    type: type,
    variant: filled ? 'filled' : 'outlined',
    icon: false,
    sx: _defineProperty({
      background: filled && theme.palette[type].main,
      color: filled && theme.palette[type].contrastText,
      width: '100%',
      '&': {
        '.MuiAlert-icon': {
          color: theme.palette[type].contrastText
        }
      }
    }, theme.breakpoints.up('sm'), {
      width: '44rem'
    })
  }), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      gap: 1,
      justifyContent: 'flex-start',
      alignItems: 'center'
    }
  }, /*#__PURE__*/isValidElement(icon) && icon, _chooseValidElement(message, {
    variant: 'body1',
    sx: {
      fontWeight: 700
    }
  })), children || _chooseValidElement(content, {
    variant: 'body2',
    sx: {
      fontWeight: 400
    }
  }));
});
BrandAlert.displayName = 'BrandAlert';
BrandAlert.propTypes = {
  type: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
  message: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  string: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  filled: PropTypes.bool,
  icon: PropTypes.element,
  onClose: PropTypes.func
};
BrandAlert.defaultProps = {
  type: 'info',
  filled: true
};
export default BrandAlert;